export default {

   base_url:'https://pm74.paymediasolutions.com/DirectSign/directsign-core-dev/public/api',
  // base_url:'https://ceylincosignpoc.paymediasolutions.com:3015/api',
  // base_public_url:'https://ceylincosignpoc.paymediasolutions.com:3015/storage/',
   base_public_url:'https://pm74.paymediasolutions.com/DirectSign/directsign-core-dev/public/storage/',

   // base_url:'http://localhost/DirectSign-Core/api',
//  base_public_url:'http://localhost/DirectSign-Core/storage/',
  customer_url: window.location.origin + "/customer/dashboard",
}
